import { render } from "./GamefamPortfolioMetricsOnQueue.vue?vue&type=template&id=1c64faa2"
import script from "./GamefamPortfolioMetricsOnQueue.vue?vue&type=script&lang=js"
export * from "./GamefamPortfolioMetricsOnQueue.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__